import React from 'react';

import { ItemCatalogModule } from '../items';
import InventoryPermissionGuard from './InventoryPermissionGuard';

export default function InventoryCatalogsModule() {
  return (
    <InventoryPermissionGuard
      permissions={[
        { resource: 'inventory.item', action: 'read' },
      ]}
    >
      <ItemCatalogModule />
    </InventoryPermissionGuard>
  );
}